/**
 * Service pour récupérer les données Minecraft via le worker backend
 */

interface MinecraftPlayerData {
  uuid: string;
  username: string;
  avatarUrl: string;
  bodyRenderUrl: string;
}

class MinecraftApiService {
  /**
   * Récupère les informations d'un joueur Minecraft (pseudo + avatar)
   * Passe par le worker backend pour éviter les problèmes CORS
   */
  async getPlayerData(uuid: string): Promise<MinecraftPlayerData> {
    try {
      const response = await fetch(`/api/minecraft/player/${uuid}`);

      if (!response.ok) {
        throw new Error('Player not found');
      }

      const data = await response.json() as { success: boolean; data?: MinecraftPlayerData };

      if (data.success && data.data) {
        return data.data;
      }

      throw new Error('Invalid response from server');
    } catch (error) {
      console.error('Error fetching Minecraft player data:', error);

      // Fallback : générer des données par défaut
      const cleanUuid = uuid.replace(/-/g, '');
      return {
        uuid: cleanUuid,
        username: `Player_${uuid.substring(0, 8)}`,
        avatarUrl: `https://crafatar.com/avatars/${cleanUuid}?size=128&overlay`,
        bodyRenderUrl: `https://crafatar.com/renders/body/${cleanUuid}?overlay`,
      };
    }
  }
}

export const minecraftApiService = new MinecraftApiService();
